var React = require('react');

function AppointmentPaid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","rx":"10","fill":"white","key":0}),React.createElement("path",{"d":"M5.5 10.3283V8.35316C5.5 7.13207 6.26038 6.26953 7.48243 6.26953H12.5176C13.7362 6.26953 14.5 7.13207 14.5 8.35316V11.6467C14.5 12.8678 13.7396 13.7298 12.5176 13.7298H10.3113","stroke":"#BDBDBD","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M14.5 8.91705H5.5","stroke":"#BDBDBD","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M5.73926 12.6178L6.84893 13.7294L9.1359 11.4414","stroke":"#BDBDBD","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

AppointmentPaid.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AppointmentPaid;

AppointmentPaid.default = AppointmentPaid;
